import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { FeatureService } from 'services';

@Component({
    selector: 'fc-feature',
    template: `<ng-content *ngIf="displayContent | async"></ng-content>`,
    standalone: false
})
export class FeatureComponent implements OnInit, OnChanges {
    @Input() name: string;
    @Input() enable: boolean;
    @Input() extraParams?: any;

    displayContent: Promise<boolean>;

    constructor(private featureService: FeatureService) {}

    ngOnInit(): void {
        this.updateDisplayContent();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateDisplayContent();
    }

    private updateDisplayContent() {
        this.displayContent = this.featureService
            .isFeatureEnabled(this.name, this.extraParams)
            .then((isFeatureEnabled) => (this.enable ? isFeatureEnabled : !isFeatureEnabled));
    }
}
